import { transformOptionValues, transformCatalogProductResponse } from '../transformers/product/index.js';

const getRangePrice = (prices, type)=>{
    if (type === 'min') {
        return prices?.[0]?._id?.min ?? 0;
    } else {
        return prices?.[prices.length - 1]?._id?.max ?? 0;
    }
};
const transformCatalogProductsLayeredPricesResponse = (data)=>data.map(({ _id , label , tot , values  })=>({
            id: _id,
            label,
            count: tot || null,
            values: values.map(({ _id , count  })=>({
                    min: _id.min,
                    max: _id.max,
                    count: count || null
                })),
            range: {
                min: getRangePrice(values, 'min'),
                max: getRangePrice(values, 'max'),
                initialMin: getRangePrice(values, 'min'),
                initialMax: getRangePrice(values, 'max')
            }
        }));
const transformCatalogProductsLayeredAttribute = ({ _id , label , tot , values  })=>({
        id: _id,
        label,
        count: tot || null,
        values: values.map(transformOptionValues)
    });
const transformCatalogProductsLayeredAttributeResponse = (data)=>data?.[0] ? transformCatalogProductsLayeredAttribute(data[0]) : null;
const transformCatalogProductsLayeredResponse = (data)=>data.map(transformCatalogProductsLayeredAttribute);
const transformCatalogProductsSortablesResponse = (data)=>[
        {
            code: 'default',
            direction: 'asc',
            label: 'Default'
        },
        ...data.reduce((acc, { code , label  })=>{
            return [
                ...acc,
                {
                    code,
                    label: label,
                    direction: 'asc'
                },
                {
                    code,
                    label: label,
                    direction: 'desc'
                }
            ];
        }, [])
    ];
const transformCatalogRecommendationProductsResponse = (data)=>data.map((item)=>transformCatalogProductResponse(item));
const transformCatalogProductsResponse = (data)=>data.map((item)=>transformCatalogProductResponse(item));

export { transformCatalogProductsLayeredAttribute, transformCatalogProductsLayeredAttributeResponse, transformCatalogProductsLayeredPricesResponse, transformCatalogProductsLayeredResponse, transformCatalogProductsResponse, transformCatalogProductsSortablesResponse, transformCatalogRecommendationProductsResponse };
